import { render, staticRenderFns } from "./AppointGroup.vue?vue&type=template&id=49222a01&scoped=true&"
import script from "./AppointGroup.vue?vue&type=script&lang=js&"
export * from "./AppointGroup.vue?vue&type=script&lang=js&"
import style0 from "./AppointGroup.vue?vue&type=style&index=0&id=49222a01&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49222a01",
  null
  
)

export default component.exports